import Vue from 'vue'
import Router from 'vue-router'
import Foot from '@/components/myFoot'
import Head from '@/components/myHead'
import Main from '@/pages/Main'
import newsList from '@/pages/newsList'
import newsContent from '@/pages/newsContent'
import Detail from '@/pages/Detail'
import mainBusiness from '@/pages/mainBusiness'
import aboutUs from '@/pages/aboutUs'
import dangQun from '@/pages/dangQun'
import Business from '@/pages/Business'
import businessDetail from '@/pages/businessDetail'
import serve from '@/pages/specialtyService'
import Culture from '@/pages/Culture'
import Recruit from '@/pages/Recruit'
import RecruitDetail from '@/pages/RecruitDetail'
import Relationus from '@/pages/Relationus'
import login from '@/pages/login'
import Register from '@/pages/Register'



Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Main',
    component: Main,
  },
  {
    path: '/Main',
    name: 'Main',
    component: Main,
    },        
    {
      path:'/newsList',
      name:'newsList',
      component:newsList
    },
    {
      path:'/newsContent',
      name:'newsContent',
      component:newsContent
    },
    {
      path: '/Detail/:new_id',
      name: 'Detail',
      component: Detail,
      //新闻详情页
    },
    {
      path:'/mainBusiness',
      name:'mainBusiness',
      component:mainBusiness  
    },
    {
      path:'/aboutUs',
      name:'aboutUs',
      component:aboutUs  
    },
    {
      path:'/dangQun',
      name:'dangQun',
      component:dangQun
    },
    {
      path:'/Business',
      name:'Business',
      component:Business
    },
    {
      path:'/businessDetail',
      name:'businessDetail',
      component:businessDetail
    },
    {
      path:'/serve',
      name:'serve',
      component: serve
    },
    {
      path:'/Culture',
      name:'Culture',
      component:Culture
    },
    {
      path:'/Recruit',
      name:'Recruit',
      component:Recruit
    },
    {
      path:'/RecruitDetail',
      name:'RecruitDetail',
      component:RecruitDetail
    },
    {
      path:'/Relationus',
      name:'Relationus',
      component:Relationus
    },
    {
      path:'/login',
      name:'login',
      component:login
    },
    {
      path:'/Register',
      name:'Register',
      component:Register
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js